export const HEATMAP_COLORS = ['#33FF00', '#FF5511', '#FFFF00', '#33FF00', '#FF5511', '#FFFF00']

export const OPACITY_HEATMAP = [0.5, 0.7, 1, 1, 1, 1]
export const OPACITY_PHEATMAP = [0.7, 0.85, 1, 1, 1, 1]

export const DOT_RADIUS = 6
export const DOT_RADIUS_SM = 1.5
